export enum TrackActions {
  TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE',
  TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR',
}
